export const SET_QUERY = 'SET_QUERY';
export const SELECTED_TIRE_SET_QUANTITY = 'SELECTED_TIRE_SET_QUANTITY'
export const mutations = {
    [SET_QUERY] (state, query) {
        state.query = query;
    },
    [SELECTED_TIRE_SET_QUANTITY](state, {quantity, productCode}) {
        function endsWithK(str) { return str.slice(-1).toLowerCase() === 'k'; }
        let searchProductCode = productCode;
        let tire = state.listReq.req.results.data.find(el => el.manufacturerproductcode == productCode);
        if (!tire) {
            if ( endsWithK(productCode) ) {
                tire = state.listReq.req.results.data.find(el => el.manufacturerproductcode == productCode.slice(0, -1));
                if (tire) searchProductCode = productCode.slice(0, -1);
            }
            if ( !endsWithK(productCode) ) {
                tire = state.listReq.req.results.data.find(el => el.manufacturerproductcode == productCode + 'K');
                if (tire) searchProductCode = productCode + 'K';
            }
        }
        if (!tire ) {
            console.log( 'No tire found with product code: ' + searchProductCode );
            return null
        }
        state.listReq.req.results.data.find(el => el.manufacturerproductcode == searchProductCode).selected_quantity = quantity
    }
};
